module.exports = __webpack_public_path__ + "img/banner.2baef30b.jpg";